module.exports = __webpack_public_path__ + "img/description2.ac6ae7ad.jpg";